export enum DeleteFileTextEnum {
  NORMAL_DELETE = '削除しますか？',
  SENDED_DELETE = 'ドキュメントが送信済みです。\n削除を続けますか？',
  NOT_ACCEPT_YET = '未受領の送信履歴があるため、削除できません。',
}
